import * as React from "react";
import * as _ from "lodash";
import * as moment from "moment-timezone";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import OrderDayPickerModal from "src/core/orders/components/Modals/OrderDayPickerModal";
import useDrop from "src/core/drops/hooks/useDrop";
import { useOrder } from "src/core/orders/hooks";
import { IOrder } from "src/core/orders/api/orders.api";
import { useProductLeadTimeGroup } from "src/core/products/hooks/useProductLeadTimeGroup";

interface DuplicateOrderModalProps {
    terminology: ITerminology,
    show: boolean;
    order: IOrder;
    closeModal: () => void;
}

/**
 * Component for a modal to duplicate an order for another delivery date
 *
 * @returns
 */
export const DuplicateOrderModal: React.ReactFCWithChildren<DuplicateOrderModalProps> = ({
  terminology, show, closeModal, order
}) => {
  const [ { drop } ] = useDrop();
  const getProductLeadtimeGroup = useProductLeadTimeGroup();

  const [ , { duplicateOrder } ] = useOrder(
    order.id,
    order,
    false
  );

  const minimumDate = React.useMemo(() => {
    const longestLeadTimes = _.max(_.map(order?.orderLines, ol => {
      const productLeadtimeGroup = getProductLeadtimeGroup(ol.product);

      if (productLeadtimeGroup) {
        return productLeadtimeGroup.defaultLeadTimeDays;
      }

      return 0;
    })) || 0;

    return moment.utc().add(longestLeadTimes, "days").toDate();
  }, [ getProductLeadtimeGroup, order?.orderLines ]);

  if (!drop) {
    return null;
  }

  return (
    <OrderDayPickerModal
      drop={drop}
      terminology={terminology}
      show={show}
      fromDate={minimumDate}
      handleDismiss={closeModal}
      modalTitle="Duplicate Order"
      onConfirm={(date, editBeforePlacing, customerReference) => {
        duplicateOrder(date, editBeforePlacing, customerReference),
        closeModal();
      }}
    />
  );
};
